import { Injectable } from '@angular/core';
import {Router, ActivatedRoute,} from "@angular/router";
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor(private router: Router) { }

  loginRedirect(){
    /* var nu_first_name = localStorage.getItem('nu_first_name');
    console.log(nu_first_name);
    if(nu_first_name == null){
      this.router.navigate(['/login']);
    } */
  }

  isUserLoggedIn(){
    var nu_first_name = localStorage.getItem('nu_first_name');
    return true;
  }

  imagePath(){
    return 'https://nuflorist.com/nfsadmin/public/images/products-images';
  }
  public static get successMessage(): string { 
    return "Your information updated successfully!"; 
  }
}


// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
          // return if another validator has already found an error on the matchingControl
          return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
          matchingControl.setErrors({ mustMatch: true });
      } else {
          matchingControl.setErrors(null);
      }
  }
}
